import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ReviewTimesheetComp from "./Component/ReviewTimesheetComp"

const ReviewTimesheet = () => {
    return (
        <>
            <Navbar />
            <div className="d-flex mainContentArea">
                <Sidebar />
                <ReviewTimesheetComp />
            </div>
            <Footer />
        </>
    )
}

export default ReviewTimesheet